import React, { useEffect, useState } from 'react';
import { postApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import DateRange from '../../components/DateRange/DateRange';
import RequestPlan from '../../components/Plan/RequestPlan';
import DateFilterInfoPopup from '../../components/Popover/DateFilterInfoPopup';
import StatsCard from '../../components/StatsCard/StatsCard';
import { accessKeys } from '../../statics/accessKeys';
import { PROFILE } from '../../statics/localStorage';
import { accessCheck } from '../../utils/accessCheck';
import { dateIntoYYYY_MM_DD } from '../../utils/dateTimeConverter';
import AttributionGraph from './Components/AttributionGraph';
import AttributionTable from './Components/AttributionTable';
import OrganicInorganicChart from './Components/OrganicInorganicChart';
import { numberToFixed } from '../../utils/general.util';

const AttributeDashboard = () => {

    const profileData = PROFILE();
    const [cardData, setCardData] = useState(null);
    const [date, setDate] = useState({ startDate: '', endDate: '' });

    const getCardsData = async () => {
        let postData = {
            "startDate": dateIntoYYYY_MM_DD(date.startDate),
            "endDate": dateIntoYYYY_MM_DD(date.endDate)
        }
        let resp = await postApi((date?.startDate ? postData : {}), urlApi?.getAttributionCardData);
        if (resp.responseCode === 200) {
            setCardData(resp.data);
        } else {
            setCardData(null);
        }
    }

    useEffect(() => {
        if (accessCheck(accessKeys?.attributionDashboard)) {
            getCardsData();
        }
    }, [date])

    function onDateChange(p) {
        let newDate = { startDate: p.startDate._d, endDate: p.endDate._d }
        setDate(newDate)
    }

    const cardKeys = [{
        key: "organicInstalls",
        name: "Organic Installs"
    }, {
        key: "inorganicInstalls",
        name: "Inorganic Installs"
    }, {
        key: "totalInstalls",
        name: "Total Installs"
    }, {
        key: "cost",
        name: "Cost"
    }, {
        key: "estimatedCPI",
        name: "Estimated CPI"
    }, {
        key: "clickCount",
        name: "Click Count"
    }, {
        key: "reTargeting",
        name: "Re-targeting"
    }, {
        key: "totalRevenue",
        name: "Total Revenue"
    }, {
        key: "organicRevenue",
        name: "Organic Revenue"
    }, {
        key: "inorganicRevenue",
        name: "Inorganic Revenue"
    }, {
        key: "reAttributionRevenue",
        name: "Re-Attribution Revenue"
    }, {
        key: "reEngagement",
        name: "Re-Engagement"
    }, {
        key: "reEngagementRevenue",
        name: "Re-Engagement Revenue"
    }, {
        key: "registrationCount",
        name: "Registration Count"
    }]

    if (profileData?.planRequestStatus != 3) {
        return (
            <RequestPlan profileData={profileData} />
        )
    }

    if (!accessCheck(accessKeys?.attributionDashboard)) {
        return <div className='py-8 text-center text-gray-400 text-xs'>You don't have access to this page</div>
    }

    return (
        <div>
            <div className="flex items-center gap-2 flex-wrap mb-2">
                <p className='text-[17px] font-bold mb-0 text-[var(--grey)]'>Overview</p>
                <DateRange onApplyClick={(date) => onDateChange(date)} date={date} cssClass={'ms-auto'} />
                {date?.startDate && <DateFilterInfoPopup />}
            </div>

            <div className="grid grid-cols-2 md:grid-cols-5 gap-2 !mb-8">
                {
                    cardKeys.map(key => (
                        <StatsCard key={key.key} title={key.name} value={numberToFixed(cardData?.[key.key]) || 0} />
                    ))
                }
            </div>

            <OrganicInorganicChart />

            <AttributionTable />

            <AttributionGraph />

        </div>
    )
}

export default AttributeDashboard